import React, { useEffect, useState } from 'react';

import { useIntl } from 'react-intl-next';

import { useAnalyticsEvents, withAnalyticsContext } from '@atlaskit/analytics-next';
import { Spotlight, SpotlightTransition } from '@atlaskit/onboarding';
import { N0 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { fireScreenAnalytics, fireUIAnalytics } from '@atlassian/analytics-bridge';

import { SPOTLIGHT_NAMES } from '../../common/constants';

import messages from './messages';

type Props = {
	stop?: () => void;
	learnMoreUrl: string;
};

const Tour = ({ stop, learnMoreUrl }: Props) => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [activeSpotlight, setActiveSpotlight] = useState<number | null>(null);

	useEffect(() => {
		const analyticsEvent = createAnalyticsEvent({
			action: 'viewed',
			actionSubject: 'spotlight',
		});
		fireScreenAnalytics(analyticsEvent);
		setActiveSpotlight(0);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const end = () => {
		const analyticsEvent = createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'button',
			actionSubjectId: 'ok',
		});
		fireUIAnalytics(analyticsEvent);
		setActiveSpotlight(null);
		stop?.();
	};

	const learnMore = () => {
		const analyticsEvent = createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'button',
			actionSubjectId: 'learnMore',
		});
		fireUIAnalytics(analyticsEvent);
	};

	const renderActiveSpotlight = () => {
		const spotlights = [
			<Spotlight
				actions={[
					{ onClick: end, text: formatMessage(messages.ok) },
					{
						onClick: learnMore,
						text: formatMessage(messages.learnMore),
						appearance: 'subtle',
						href: learnMoreUrl,
						target: '_blank',
					},
				]}
				heading={formatMessage(messages.heading)}
				key={SPOTLIGHT_NAMES.actions}
				target={SPOTLIGHT_NAMES.actions}
				targetRadius={3}
				targetBgColor={token('elevation.surface', N0)}
			>
				{formatMessage(messages.description)}
			</Spotlight>,
		];

		if (activeSpotlight === null) {
			return null;
		}
		return spotlights[activeSpotlight];
	};

	return <SpotlightTransition>{renderActiveSpotlight()}</SpotlightTransition>;
};

export const HeartbeatsTour = withAnalyticsContext({
	source: 'OpsHeartbeatsSpotlightTour',
	tags: ['spotlight', 'ops-heartbeats-spotlight'],
})(Tour);
